const MAX_FILE_SIZE = 25 * 1024 * 1024;
const MAX_TOTAL_SIZE = 60 * 1024 * 1024;

const isTooManyFiles = (files: File[], maxFilesAmount: number) => files.length > maxFilesAmount;
const isWrongSize = (file: File) => file.size > MAX_FILE_SIZE;
const isListOversized = (files: File[]) => {
    const totalSize = files.reduce((prev, current) => prev + current.size, 0);
    return totalSize > MAX_TOTAL_SIZE;
};

export const fileValidation = (prevFiles: File[], newFiles: File[], maxFilesAmount: number) => {
    const filesBelowSizeLimit = [];
    const filesAboveSizeLimit = [];

    const errors = {tooManyFiles: false, wrongSizeFilenames: [], listOversized: false};

    if (isTooManyFiles([...prevFiles, ...newFiles], maxFilesAmount)) {
        return {files: [...prevFiles, ...newFiles].slice(0, maxFilesAmount), errors: {...errors, tooManyFiles: true}};
    }

    if (isListOversized([...prevFiles, ...newFiles])) {
        return {files: [...prevFiles], errors: {...errors, listOversized: true}};
    }

    for (const file of newFiles) {
        if (isWrongSize(file)) {
            filesAboveSizeLimit.push(file);
        } else {
            filesBelowSizeLimit.push(file);
        }
    }

    if (filesAboveSizeLimit.length) {
        return {
            files: [...prevFiles, ...filesBelowSizeLimit],
            errors: {...errors, wrongSizeFilenames: filesAboveSizeLimit.map(file => file.name)},
        };
    }

    return {files: [...prevFiles, ...newFiles], errors};
};
